export const fonts = {
	body: '"Roboto", "Helvetica", "Arial", sans-serif',
	heading: '"Roboto", "Helvetica", "Arial", sans-serif',
};

export const fontWeights = {
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 700,
	bold: 900,
};

export const fontSizes = [
	'0.75rem', // 12px
	'0.875rem', // 14px
	'1rem', // 16px
	'1.125rem', // 18px
	'1.25rem', // 20px
	'1.5rem', // 24px
	'1.875rem', // 30px
	'2.25rem', // 36px
	'3rem', // 48px
	'3.75rem', // 60px
	'4.5rem', // 72px
	'6rem', // 96px
	'8rem', // 128px
];
// Aliases
fontSizes['xs'] = fontSizes[0];
fontSizes['sm'] = fontSizes[1];
fontSizes['md'] = fontSizes[2];
fontSizes['lg'] = fontSizes[3];
fontSizes['xl'] = fontSizes[4];
fontSizes['2xl'] = fontSizes[5];
fontSizes['3xl'] = fontSizes[6];
fontSizes['4xl'] = fontSizes[7];
fontSizes['5xl'] = fontSizes[8];
fontSizes['6xl'] = fontSizes[9];
fontSizes['7xl'] = fontSizes[10];
fontSizes['8xl'] = fontSizes[11];
fontSizes['9xl'] = fontSizes[12];

export const lineHeights = [
	1,
	1.25,
	1.5,
	'0.75rem',
	'1rem',
	'1.25rem',
	'1.5rem',
	'1.75rem',
	'2rem',
	'2.25rem',
	'2.5rem',
];
// Aliases
lineHeights['normal'] = 'normal';
lineHeights['none'] = 1;
lineHeights['shorter'] = 1.25;
lineHeights['short'] = 1.375;
lineHeights['base'] = 1.5;
lineHeights['tall'] = 1.625;
lineHeights['taller'] = 2;
